<div class="modal-header">
  <h4 class="modal-title float-left">{{ title | translate }}</h4>
</div>

<div class="modal-body" [innerHtml]="message | translate"></div>

<div class="modal-footer">

  @if (pending) {
      <div class="d-flex w-100 justify-content-center">
        <div class="ball-clip-rotate"><div></div></div>
      </div>
  } @else {
      <div class="d-flex w-100">
          @if (closeBtn) {
            <button type="button" class="btn text-secondary btn-outline-secondary" (click)="closeAction()">{{ closeText | translate}}</button>
          }
          @if (cancelBtn) {
            <button type="button" class="btn ml-0" [ngClass]="cancelClass" (click)="cancelAction()">{{ cancelTxt | translate}}</button>
          }
          <div class="flex-grow-1"></div>
          @if (resetBtn) {
            <button type="button" class="btn ml-3" [ngClass]="resetClass" (click)="resetAction()">{{ resetTxt | translate}}</button>
          }
          @if (proceedBtn) {
            <button type="button" class="btn ml-3" [ngClass]="proceedClass" (click)="proceedAction()">{{ proceedTxt | translate}}</button>
          }
      </div>
  }

</div>
